import TestInvitations from "@/components/student/TestInvitations";
import ParentInvitations from "@/components/student/ParentInvitations";

const StudentInvitations = () => {
  return (
    <div className="container mx-auto px-4 py-8 space-y-6">
      <header>
        <h1 className="text-3xl font-bold">Invitations</h1>
        <p className="text-muted-foreground">
          Test invitations from instructors and parent connection requests.
        </p>
      </header>
      <ParentInvitations />
      <TestInvitations />
    </div>
  );
};

export default StudentInvitations;
